<template>
  <div class="login_container">
    <div class="img-form">
      <div class="avatar_box">
        <img src="../assets/images/login/bg2.png" alt="">
        <div class="footer-container">
          <!--        <div class="footer">千仓科技供应链，专注中日国际物流</div>-->
          <!--        <div class="about">Copyright © www.zxwl.com, All Rights Reserved.</div>-->
        </div>
      </div>
      <div class="login_box pon">
        <!-- 表单 -->
        <div class="login_box_content">
          <div class="img-container">
            <!--            <img src="../assets/images/login/login_biaoti.png" alt="">-->
            <img src="../assets/images/login/login_biaoti6.png" alt="">
          </div>
          <el-form ref="LoginFormRef" :model="loginForm" label-width="0" :rules="LoginFormRules" class="login_form">
            <el-form-item prop="userName">
              <el-input
                  v-model="loginForm.userName"
                  prefix-icon="el-icon-user-solid"
                  placeholder="请输入登录ID/手机号"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                  v-model="loginForm.password"
                  prefix-icon="el-icon-lock"
                  type="password"
                  placeholder="请输入密码"
                  @keyup.enter.native="login"></el-input>
            </el-form-item>
            <el-button class="btns" type="primary" @click="login" size="small"><span>登录</span></el-button>
          </el-form>

        </div>
        <div class="filing">
<!--          <a href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备2021007835号-2</a>-->
        </div>
<!--        <div class="registerText" style="overflow:hidden">-->
<!--          <span style="float:left;height:22px;line-height:22px;margin-right:5px">没有账号，现在就去</span>-->
<!--          <span style="float:left;height:22px;line-height:20px"><el-link type="primary" :underline="false"@click="register">注册</el-link></span>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loginForm: {
        userName: '',
        password: ''
      },
      LoginFormRules: {
        userName: [
          {required: true, message: '请输入用户名', trigger: 'blur'},
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
        ]
      }
    }
  },
  methods: {
    resetLoginForm() {
      this.$refs.LoginFormRef.resetFields()
    },
    login() {
      this.$refs['LoginFormRef'].validate(async (valid) => {
        if (valid) {
          const {data: res} = await this.$http.post('admin/login', this.loginForm)
          if (res.code == 200) {
            this.$message({
              message: '登录成功',
              type: 'success'
            })
            window.sessionStorage.setItem('token', res.data.tokenHead + res.data.token);
            window.sessionStorage.setItem('username', this.loginForm.userName);

            //权限数组
            // var authArr = ['add','edit'];
            // window.sessionStorage.setItem('auth',authArr.toString());
            this.$router.push('/');
          } else {
            this.$message({
              message: res.message,
              type: 'error'
            })
          }
        } else {
          return false
        }
      })
    },
    register() {
      window.sessionStorage.clear;
      this.$router.push({name: '/register'});
    }
  }
}
</script>

<style lang="less" scoped>
.el-form-item {
  height: 40px !important;
}

.el-input__inner {
  font-size: inherit;
}

.login_container {
  height: 100%;
  width: 100%;
  // background: url("../assets/images/login/bg.png") no-repeat;
  background-size: cover;
}

//.login_box{
//  position: relative;
//}
.registerText {
  position: absolute;
  bottom: -4%;
  right: 26%;

}

.login_box_content {
  //padding: 15%;
  //padding-top: 45%;
  .img-container {
    padding-bottom: 20px;

    img {
      //width: 188px;
      height: 77px;
    }
  }
}

.img-form {
  overflow: hidden;
  height: 100%;
  position: relative;

  .avatar_box {
    //position: relative;
    //float: left;
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .login_box {
    //float: left;
    position: absolute;
    width: 290px;
    height: 326px;
    left: 208px;
    //margin: 0 auto;
    top: 50%;
    margin-top: -163px;
    //background-color: red;
  }
}

@media screen and (min-width: 1600px) {
  //.avatar_box{
  //  width: 75% !important;
  //}
  //.login_box{
  //  width: 25% !important;
  //}
}



.login_form {
  bottom: 0;
  width: 100%;
  padding: 0px;
  box-sizing: border-box;
}

.btns {
  margin-top: 20px;
  width: 263px;
  height: 38px;
  background: linear-gradient(90deg, #269F98, #2E85A1);
  border-radius: 20px;
  color: #ffffff;
}

.btns span {
  font-size: 17px !important;
  letter-spacing: 5px;
}

/deep/ .el-input__prefix, .el-input__suffix {
  color: #2E85A1 !important;
}

/deep/ .el-input__icon .el-icon-user-solid {
  color: #2E85A1 !important;
}

.footer-container {
  width: 100%;
  position: absolute;
  bottom: 10%;
  text-align: center;
}

.footer {
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  letter-spacing: 4px;
  color: #FEFEFF;
}

.about {
  font-size: 16px;
  font-family: Source Han Sans CN;
  // font-weight: 400;
  color: #FEFEFF;
  padding-top: 10px;
}

/deep/ .el-input__inner {
  border: none !important;
  border-bottom: 1px solid #E5E9F8 !important;
}

/deep/ .el-input--prefix .el-input__inner {
  padding-left: 40px !important;
}
.pon{
  position: relative;
  .filing{
    position: fixed;
    left: 47%;
    bottom: 20px;
  }
}
</style>
